"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScriptPropertiesToJSON = exports.ScriptPropertiesFromJSONTyped = exports.ScriptPropertiesFromJSON = exports.instanceOfScriptProperties = void 0;
var runtime_1 = require("../runtime");
var ReferenceFile_1 = require("./ReferenceFile");
/**
 * Check if a given object implements the ScriptProperties interface.
 */
function instanceOfScriptProperties(value) {
    var isInstance = true;
    isInstance = isInstance && "talkingPoints" in value;
    isInstance = isInstance && "callToAction" in value;
    return isInstance;
}
exports.instanceOfScriptProperties = instanceOfScriptProperties;
function ScriptPropertiesFromJSON(json) {
    return ScriptPropertiesFromJSONTyped(json, false);
}
exports.ScriptPropertiesFromJSON = ScriptPropertiesFromJSON;
function ScriptPropertiesFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'talkingPoints': json['talking_points'],
        'callToAction': json['call_to_action'],
        'website': !(0, runtime_1.exists)(json, 'website') ? undefined : json['website'],
        'referenceFiles': !(0, runtime_1.exists)(json, 'reference_files') ? undefined : (json['reference_files'].map(ReferenceFile_1.ReferenceFileFromJSON)),
        'isAiScript': !(0, runtime_1.exists)(json, 'is_ai_script') ? undefined : json['is_ai_script'],
        'phrasesToInclude': !(0, runtime_1.exists)(json, 'phrases_to_include') ? undefined : json['phrases_to_include'],
        'phrasesToExclude': !(0, runtime_1.exists)(json, 'phrases_to_exclude') ? undefined : json['phrases_to_exclude'],
    };
}
exports.ScriptPropertiesFromJSONTyped = ScriptPropertiesFromJSONTyped;
function ScriptPropertiesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'talking_points': value.talkingPoints,
        'call_to_action': value.callToAction,
        'website': value.website,
        'reference_files': value.referenceFiles === undefined ? undefined : (value.referenceFiles.map(ReferenceFile_1.ReferenceFileToJSON)),
        'is_ai_script': value.isAiScript,
        'phrases_to_include': value.phrasesToInclude,
        'phrases_to_exclude': value.phrasesToExclude,
    };
}
exports.ScriptPropertiesToJSON = ScriptPropertiesToJSON;
